import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { RiShieldKeyholeFill } from "react-icons/ri";
import { UserContext } from "../contexts/UserContext";

const UnauthorizedPage = () => {
  const navigate = useNavigate();
  const { clearUserData } = useContext(UserContext);

  const handleBackHome = () => {
    navigate("/dashboard");
  };

  const handleLogin = () => {
    clearUserData();
    navigate("/");
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100">
      <div className="text-center">
        <div className="p-8 bg-white shadow-lg rounded-lg flex items-center space-x-4">
          <RiShieldKeyholeFill className="text-red-500 text-8xl" />
          <h1 className="text-4xl font-bold text-gray-800">
            403 - nicht autorisierte Seite
          </h1>
        </div>

        <p className="text-lg text-gray-600 mt-4">
          You don’t have permission to access this page.
        </p>
        <div className="flex justify-center space-x-4 mt-6">
          <button
            onClick={handleBackHome}
            className="bg-blue-500 text-white px-6 py-3 rounded-lg shadow-md hover:bg-blue-600 focus:outline-none"
          >
            Go to Homepage
          </button>
          <button
            onClick={handleLogin}
            className="bg-gray-800 text-white px-6 py-3 rounded-lg shadow-md hover:bg-gray-900 focus:outline-none"
          >
            Log In
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
